
import u from "umbrellajs"
import Pikaday from "pikaday"


import I18n from "plugins/i18n-js"


const INIT_DONE_CLASS = "js-pikaday--init-done"
const MIN_DATE_DISABLED_CLASS = "js-pikaday--min-date-disabled"

// region options

interface ExtraOptions {
  triggerSelectEvent: boolean
  useNumericFormat: boolean
  minDateEnabled: boolean
}
type ExtraOptionsInput = Partial<ExtraOptions>

const DEFAULT_OPTIONS: ExtraOptions = {
  triggerSelectEvent: false,
  useNumericFormat:   false,
  minDateEnabled:     true,
}

// endregion options

const init = (selector: string = ".js-pikaday", input_options: ExtraOptionsInput = {}) => {
  u(selector).each((el) => {
    const $el = u(el)
    if (el.classList.contains(INIT_DONE_CLASS)) { return }

    el.classList.add(INIT_DONE_CLASS)

    // region options

    const options: ExtraOptions = Object.assign({}, DEFAULT_OPTIONS, input_options)

    // endregion options


    let pikaday_options: Pikaday.PikadayOptions = {
      field:          el as HTMLElement,
      setDefaultDate: true,
      onSelect:       () => {
        if (options.triggerSelectEvent){
          $el.trigger("filter:date_update")
        }
      },
      i18n: {
        months: [
          I18n.t("formats.datetime.month_in_words.jan"),
          I18n.t("formats.datetime.month_in_words.feb"),
          I18n.t("formats.datetime.month_in_words.mar"),
          I18n.t("formats.datetime.month_in_words.apr"),
          I18n.t("formats.datetime.month_in_words.may"),
          I18n.t("formats.datetime.month_in_words.june"),
          I18n.t("formats.datetime.month_in_words.july"),
          I18n.t("formats.datetime.month_in_words.aug"),
          I18n.t("formats.datetime.month_in_words.sep"),
          I18n.t("formats.datetime.month_in_words.oct"),
          I18n.t("formats.datetime.month_in_words.nov"),
          I18n.t("formats.datetime.month_in_words.dec"),
        ],
        weekdays: [
          I18n.t("formats.datetime.day_in_words.sun"),
          I18n.t("formats.datetime.day_in_words.mon"),
          I18n.t("formats.datetime.day_in_words.tue"),
          I18n.t("formats.datetime.day_in_words.wed"),
          I18n.t("formats.datetime.day_in_words.thu"),
          I18n.t("formats.datetime.day_in_words.fri"),
          I18n.t("formats.datetime.day_in_words.sat"),
        ],
        weekdaysShort: [
          I18n.t("formats.datetime.day_in_words.sun"),
          I18n.t("formats.datetime.day_in_words.mon"),
          I18n.t("formats.datetime.day_in_words.tue"),
          I18n.t("formats.datetime.day_in_words.wed"),
          I18n.t("formats.datetime.day_in_words.thu"),
          I18n.t("formats.datetime.day_in_words.fri"),
          I18n.t("formats.datetime.day_in_words.sat"),
        ],
        previousMonth:  "Previous Month",
        nextMonth:      "Next Month",
      },
    }

    // Either passing the option with `false`
    // or having the class name will disable
    const minDateEnabled =
      options.minDateEnabled &&
      !el.classList.contains(MIN_DATE_DISABLED_CLASS)
    if (minDateEnabled){
      pikaday_options = Object.assign({minDate: new Date()}, pikaday_options)
    }

    if (options.useNumericFormat){
      pikaday_options = Object.assign(
        pikaday_options,
        {
          toString(date: Date, _format: any) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
          },
        },
      )
    }

    new Pikaday(pikaday_options)
  })
}

export default {init}
